import React from "react";
import { Checkbox } from "antd";

const AnswerMultiChoice = ({ question }) => {
	return (
		<div className="answers-container">
			{question.answers.map((answer) => (
				<div key={answer.id} className="answer-item">
					<Checkbox>{answer.name}</Checkbox>
				</div>
			))}
		</div>
	);
};

export default AnswerMultiChoice;
